import { useRef } from "react";
import { useEffect } from "react";
import "../../../assets/style/featuresStyle/button.scss";
import { useState } from "react";
import { IconAddIMG, IconEdit } from "../../../assets/icon";
import { useDispatch } from "react-redux";
import { setNotifyGlobal } from "../../../services/slice/AccountSlice";
import ModalCropImage from "../Modal/other/ModalCropImage";
const UpImageEdit = ({
  serverBanner,
  setImage,
  width,
  height,
  url,
  className,
  style,
  image,
  accept,
  widthImage,
  heightImage,
  setFile,
  isCropImage = true,
}) => {
  const [changed, setChanged] = useState(false);
  const [isPreview, setIsPreview] = useState(url ? true : false);
  const [previewIMG, setPreviewIMG] = useState();
  const [openModalEdit, setOpenModalEdit] = useState(false);
  const dispatch = useDispatch();
  useEffect(() => {
    if (changed && image) {
      setPreviewIMG(image);
      return;
    }
  }, [changed]);
  // const handlePreviewIMG = (e) => {
  //   const file = e.target.files[0];
  //   const allowedFormats = ["image/jpeg", "image/jpg", "image/png"];
  //   if (!allowedFormats.includes(file.type)) {
  //     dispatch(
  //       setNotifyGlobal({
  //         msg: "Chọn sai định dạng vui lòng chọn lại",
  //         type: "error",
  //       })
  //     );
  //     return;
  //   }

  //   file.preview = URL.createObjectURL(file);
  //   setImage(file);
  //   setOpenModalEdit(true);
  // };
  const handlePreviewIMG = (e) => {
    const file = e.target.files[0];
    const allowedFormats = ["image/jpeg", "image/jpg", "image/png"];
    if (!allowedFormats.includes(file.type)) {
      dispatch(
        setNotifyGlobal({
          msg: "Chọn sai định dạng, vui lòng chọn lại",
          type: "error",
        })
      );
      return;
    }

    file.preview = URL.createObjectURL(file);
    setImage(file);
    setOpenModalEdit(true);
  };

  const inputRef = useRef();
  useEffect(() => {
    if (previewIMG) {
      setIsPreview(false);
    }
  }, [previewIMG]);
  useEffect(() => {
    if (previewIMG) {
      setIsPreview(false);
    }
  }, [previewIMG]);
  useEffect(() => {
    return () => {
      previewIMG && URL.revokeObjectURL(previewIMG.preview);
    };
  }, [previewIMG]);
  const handleChooseImage = (e) => {
    inputRef.current.click();
  };
  const styleBtn = {
    width,
    height,
  };

  useEffect(() => {
    if (url) {
      setIsPreview(true);
    }
  }, [url]);
  return (
    <div className={`btnChooseImage ${className}`} style={styleBtn}>
      {openModalEdit ? (
        <ModalCropImage
          setChanged={setChanged}
          isOpen={openModalEdit}
          setImage={setImage}
          image={image}
          setIsOpen={setOpenModalEdit}
          widthImage={widthImage}
          heightImage={heightImage}
          setFile={setFile}
        />
      ) : null}
      <input
        type="file"
        ref={inputRef}
        accept={accept}
        style={{ display: "none" }}
        onChange={handlePreviewIMG}
      />
      {previewIMG && !isPreview ? (
        <div className="haveIMG" style={style}>
          <span className="iconChange" onClick={handleChooseImage}>
            <IconEdit />
          </span>
          <img src={previewIMG} width={200} alt="img"></img>
        </div>
      ) : !previewIMG && !isPreview ? (
        <div className="noIMG">
          <div className="upload" style={style} onClick={handleChooseImage}>
            <IconAddIMG />
          </div>
        </div>
      ) : (
        <div className="haveIMG" style={style}>
          <span className="iconChange" onClick={handleChooseImage}>
            <IconEdit />
          </span>
          <img
            src={`${
              serverBanner ? window.SERVER_URL_ADS : window.SERVER_URL
            }/${url}`}
            width={200}
            alt="img"
          ></img>
        </div>
      )}
    </div>
  );
};
export default UpImageEdit;
